import React from 'react'
import FlexView from 'react-flexview/lib'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { Collapse } from '@material-ui/core'
import { ActiveInsuranceModel } from '../../../../models/insurance-models/ActiveInsuranceModel'
import { AdditionalCoverages } from "./AdditionalCoverages"
import { DronesAndEquipment } from "./DronesAndEquipment"
import { Liability } from "./Liability"
import { NumberOfDrones } from "./NumberOfDrones"
import { TotalPrice } from './TotalPrice'

interface CoverageDetailsProps {
    insurance: ActiveInsuranceModel,
    isRenewal: boolean,
    isExpanded: boolean,
    setIsExpanded: (isExpanded: boolean) => void,
    shrink: boolean
}   


export const CoverageDetails = ({shrink , insurance, isRenewal, isExpanded, setIsExpanded}: CoverageDetailsProps) => {
    return (
        <FlexView column={true} vAlignContent="center" className="space-between padding-vertical-basic">
            <FlexView className="space-between">
                <FlexView vAlignContent="center" className="text-body bold">Coverage Details</FlexView>
                <FlexView 
                    onClick={() => setIsExpanded(!isExpanded)}
                    className='clickable'
                >

                {!shrink && <FlexView vAlignContent="center" marginRight={8} className='bold blue' >
                        {isExpanded ? 'Hide' : 'Show'}
                    </FlexView>}
                    <ExpandMoreIcon fontSize="small"
                    className="blue margin-right-small"
                    style={{ 
                        transform: isExpanded ? 'rotate(180deg)' : 'rotate(0)',
                        transition: 'transform 0.3s'
                    }}
                    />
                    </FlexView>
            </FlexView>
            
            <Collapse in={isExpanded} timeout="auto" unmountOnExit className="full-width">
                <FlexView column={true} marginTop={24} marginLeft={15}>
                    <Liability 
                        isLiabilitySpecialPrice={!isRenewal ? insurance.isLiabilitySpecialPrice : insurance.subscription.isLiabilitySpecialPrice}
                        liabilityLimit={!isRenewal ? insurance.liabilityLimit : insurance.subscription.liabilityLimit}
                        totalLiabilityPremium={!isRenewal ? insurance.totalLiabilityPremium : insurance.subscription.liabilityLimitPremium}
                    />
                    <NumberOfDrones 
                        numberOfDronesOperate={!isRenewal ? insurance.numberOfDronesOperate : insurance.subscription.numberOfDronesOperate} 
                    />
                    <DronesAndEquipment 
                        insuredDrones={!isRenewal ? insurance.insuredDrones : insurance.subscription.drones} 
                        insuredEquipment={!isRenewal ? insurance.insuredEquipment : insurance.subscription.equipment} 
                    />
                    <AdditionalCoverages 
                        personalInjuryLimit={!isRenewal ? insurance.personalInjuryLimit : insurance.subscription.personalInjuryLimit}
                        medicalExpenseLimit={!isRenewal ? insurance.medicalExpenseLimit : insurance.subscription.medicalExpenseLimit}
                        personalInjuryLimitPremium={!isRenewal ? insurance.personalInjuryLimitPremium : insurance.subscription.personalInjuryLimitPremium}
                        medicalExpenseLimitPremium={!isRenewal ? insurance.medicalExpenseLimitPremium : insurance.subscription.medicalExpenseLimitPremium}
                    />
                    <TotalPrice 
                        totalPrice={!isRenewal ? insurance.finalPrice : insurance.subscription.totalPrice}
                    />
                </FlexView>
            </Collapse>
        </FlexView>
    )
}